module.exports = __webpack_public_path__ + "static/media/German_Angela BG-38.c151ae89.png";